import AppStoreLogo from "@/assets/images/appstore.png";
import Logo from "@/assets/images/logo.png";
import PlayStoreLogo from "@/assets/images/playstore.png";
import { Spacer } from "@/components/Spacer";
import { trackAppDownload } from "@/utils/analytics";
export default function Section10({ isMobile }: { isMobile: boolean }) {
  return (
    <div
      id="section10"
      className="w-full flex flex-row justify-between items-center bg-[linear-gradient(105deg,_#F1F2FF_0%,_#CED4FF_90.67%)] pt-[45px] desktop:pl-[70px] desktop:pr-[0px] pl-[24px] relative"
    >
      <div className="flex flex-col items-start desktop:min-w-[329px] desktop:w-[329px] desktop:h-[490px] w-full desktop:justify-center justify-start desktop:mb-[0px] mb-[31px] z-10">
        <img
          src={Logo}
          alt="logo"
          className="desktop:w-[273px] desktop:h-[44px] w-[87px] h-[15px]"
        />
        <Spacer height={isMobile ? 8 : 20} />
        <div
          className="font-pre-regular text-[#000000] desktop:text-[24px] text-[13px] leading-[140%]"
          style={{ letterSpacing: "-0.3px" }}
        >
          걱정되는 증상을{" "}
          <span className="font-pre-bold">제때에 쉽고 빠르게</span>
        </div>
        <Spacer height={isMobile ? 16 : 32} />
        <div className="flex flex-row items-center desktop:gap-[16px] gap-[8px]">
          <PlayStore />
          <AppStore />
        </div>
      </div>

      <img
        src={
          isMobile
            ? "assets/images/section-10-01-mobile.png"
            : "assets/images/section-10-01-desktop.png"
        }
        alt="section10-image"
        className="desktop:w-[1080px] desktop:h-[490px] h-[120px] desktop:static absolute right-[0px] z-0 bottom-0"
      />
    </div>
  );
}

const AppStore = () => {
  return (
    <div
      onClick={() => {
        trackAppDownload("app_store");
        window.open(
          "https://apps.apple.com/kr/app/%ED%97%AC%EC%8B%9C%EC%96%B4-%EC%95%84%ED%94%8C-%EB%95%8C-%EA%B0%80%EC%9E%A5-%EB%A8%BC%EC%A0%80-%EB%A7%8C%EB%82%98%EB%8A%94-%EB%8B%A5%ED%84%B0ai/id6471542545",
          "_blank"
        );
      }}
      className="cursor-pointer flex justify-left items-center desktop:gap-[8px] gap-[4px] desktop:pl-[12px] pl-[10px] desktop:pr-[14px] pr-[8px] desktop:py-[12px] py-[8px] bg-[#ffffff] rounded-[10px]"
    >
      <img
        src={AppStoreLogo}
        alt="AppStore"
        className="desktop:w-[28px] desktop:h-[28px] w-[24px] h-[24px]"
      />
      <div className="font-pre-bold desktop:text-[18px] text-[14px] leading-[1.3em] text-[#000000]">
        App Store
      </div>
    </div>
  );
};

const PlayStore = () => {
  return (
    <div
      onClick={() => {
        trackAppDownload("play_store");
        window.open(
          "https://play.google.com/store/apps/details?id=com.healthier&hl=ko",
          "_blank"
        );
      }}
      className="cursor-pointer flex justify-left items-center desktop:gap-[8px] gap-[4px] desktop:pl-[12px] pl-[10px] desktop:pr-[14px] pr-[8px] desktop:py-[12px] py-[8px] bg-[#2E323A] rounded-[10px]"
    >
      <img
        src={PlayStoreLogo}
        alt="PlayStore"
        className="desktop:w-[28px] desktop:h-[28px] w-[24px] h-[24px]"
      />
      <div className="font-pre-bold desktop:text-[18px] text-[14px] leading-[1.3em] text-[#ffffff]">
        Google Play
      </div>
    </div>
  );
};
